import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

const FitsDetails = ({ fits }) => {
    const { t } = useTranslation();

    if (!fits || fits.length === 0) return null;

    return (
        <div className='fits-details'>
            <b>{t('activeFits')}</b>
            <div className='fits-details__list'>
                {fits.map((fit) => (
                    <div key={fit.id} className='fits-details__item'>
                        <div className='fits-details__item-grid'>
                            <span className='fits-details__req'>#{fit.requisitionCode}</span>
                            {fit.fitBy && (
                                <span className='fits-details__by'>by @{fit.fitBy}</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

FitsDetails.defaultProps = {
    fits: [],
};

export { FitsDetails };
